import { PermissionsService } from './../services/auth/permissions.service';
import { GlobalParamsService } from '@services/global-params/global-params.service';
import { Directive, HostListener, Input, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ImportAlmDatasetComponent } from '@components/simulation/import-alm-dataset/import-alm-dataset.component';
import { DialogComponent } from '@core/dialog/dialog.component';
import { DatasetsService } from '@services/datasets/datasets.service';
import { MenuService } from '@services/menu/menu.service';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ImporterService } from '@services/datasets/importer.service';
import { EmpyreanDialogType } from '@interfaces/types/empyrean-dialog-type';

@Directive({
  selector: '[appLaunchMainDialog]',
})
export class LaunchMainDialogDirective implements OnDestroy {
  private subscriptions: Subscription[] = [];
  public maximized = false;
  private dialogRef: MatDialogRef<DialogComponent | ImportAlmDatasetComponent>;
  private userRoleCanImport: boolean;

  @Input() appLaunchMainDialog: EmpyreanDialogType;
  @Input() menuOption: number;

  constructor(
    public dialog: MatDialog,
    private menu: MenuService,
    private dsService: DatasetsService,
    private importerService: ImporterService,
    private globalParams: GlobalParamsService,
    private permissions: PermissionsService
  ) {
    const maximizedSubscription = this.menu.maximized$.pipe(distinctUntilChanged()).subscribe(value => {
      if (this.maximized !== value) {
        this.maximized = value;
        this.maximizeOrRestore();
      }
    });
    this.subscriptions.push(maximizedSubscription);
  }

  @HostListener('click') onClick() {
    if (this.menuOption) {
      this.menu.selectMenuItem(this.menu.simulationMenu[this.menuOption]);
    }
    this.openDialog(this.appLaunchMainDialog);
  }

  public async openDialog(type: EmpyreanDialogType) {
    const dialogOptions = {
      height: this.maximized ? 'calc(100% - 50px)' : 'calc(100% - 140px)',
      width: this.maximized ? '100%' : 'calc(100% - 140px)',
      position: this.maximized ? { bottom: '0px !important' } : { bottom: '' },
      maxWidth: '100vw',
      panelClass: ['ui-dialog-content'],
      disableClose: true,
      data: { type },
    };

    // This set up the button on the importer screen to DONE if the import was loaded using the Import button
    if (type === 'sim-importer') {
      this.importerService.dialogLoadedFrom = 'import-button';
      this.dsService.getRequiredDatasetImport();
    }

    if (type === 'simulation') {
      if (this.globalParams.ignoreImportWarning) {
        type = 'simulation';
        dialogOptions.data = { type: 'simulation' };
      } else {
        await this.dsService.getRequiredDatasetImport().then(res => {
          this.userRoleCanImport = this.permissions.getPermission('Import') === 'W';
          if (res === false || !this.userRoleCanImport) {
            type = 'simulation';
            dialogOptions.data = { type: 'simulation' };
          } else {
            type = 'sim-importer';
            dialogOptions.data = { type: 'sim-importer' };
          }
        });
      }
      // We will set up a flag so we can display a CONTINUE button after import on the Import Dialog
      // that will move the user to the Simulation dialog
      this.importerService.dialogLoadedFrom = 'sim-button';
    }

    this.dialogRef = this.dialog.open(DialogComponent, dialogOptions);

    const keyDownEventsSubscription = this.dialogRef.keydownEvents().subscribe(e => {
      // Ctrl + M maximizes / restores the dialog
      if (e.key.toLowerCase() === 'm' && e.ctrlKey) {
        this.menu.toggleMaximized();
      }
    });
    this.subscriptions.push(keyDownEventsSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  private maximizeOrRestore() {
    if (this.dialogRef) {
      try {
        if (this.maximized) {
          this.dialogRef.updatePosition({ bottom: '0px !important' });
          this.dialogRef.updateSize('100%', 'calc(100% - 50px)');
        } else {
          this.dialogRef.updatePosition({ bottom: '' });
          this.dialogRef.updateSize('calc(100% - 140px)', 'calc(100% - 140px)');
        }
        // this.menu.emitResize();
      } catch (error) {
        // console.warn(error);
      } finally {
        this.menu.emitResize();
      }
    }
  }
}
